/** Circular spinner for loading states; use with the animate-spin class for the rotation animation. */

import { ColorIconWrapper } from '../IconWrapper.tsx';
import type { IconProps } from '@federa/types/ui-icons';

/** Circular spinner icon: unlike the line-based LoaderIcon this uses a circular path for smoother rotation, with fill and stroke via ColorIconWrapper. */
export function SpinnerIcon(props: IconProps) {
	return (
		<ColorIconWrapper {...props}>
			{(c) => (
				<>
					<circle cx="12" cy="12" r="10" stroke={c} strokeWidth="4" opacity="0.25" />
					<path
						fill={c}
						opacity="0.75"
						d="m4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
					/>
				</>
			)}
		</ColorIconWrapper>
	);
}
